import { OrderProcessItemQcServiceProxy } from "@/service-proxies/app-v2/coproduction.service-proxies";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import QualityTesting from './QualityTesting.vue'

const opiqsp = new OrderProcessItemQcServiceProxy()
@Component({
  components: {
    QualityTesting
  }
})
export default class ProductionTable extends Vue {
  @Prop({ default: {} }) readonly plan: any
  @Prop({ default: () => {} }) readonly searchDto: any

  @Watch('plan',{immediate: true,deep:true})

  checkPlan(){
    if(!this.plan.id) return
    this.reload()
  }

  reload(){
    this.page.current = 1
    this.getList()
  }
  created(){
    this.getList()
    this.$nextTick(() =>{
      this.getHeight()
    })
  }

  async getList(){
    this.loading = true
    const res = await opiqsp.page(this.page)
    this.data = res.records
    this.total = Number(res.total)
    this.loading = false
  }

  get columns(){
    return [
      {
        title: this.$t('page_plan_order_no'),
        dataIndex: 'orderCode',
        key: 'orderCode',
        ellipsis: true
      },{
        title: this.$t('page_standard_process_procedure_code'),
        dataIndex: 'processCode',
        key: 'processCode',
        ellipsis: true
      },{
        title: this.$t('page_process_name'),
        dataIndex: 'processName',
        key: 'processName',
        ellipsis: true
      },{
        title: this.$t('page_job_plan_workstation_work'),
        dataIndex: 'workStationName',
        key: 'workStationName',
        ellipsis: true
      },{
        title: this.$t('page_plan_process_persoal'),
        dataIndex: 'producerName',
        key: 'producerName',
        ellipsis: true
      },{
        title: this.$t('page_bussiness_data_quality_name_of_quality'),
        dataIndex: 'itemName',
        key: 'itemName',
        ellipsis: true
      },{
        title: this.$t('page_job_plan_standard_value'),
        dataIndex: 'standardValue',
        key: 'standardValue',
        ellipsis: true
      },{
        title: this.$t('page_job_plan_measured_value'),
        dataIndex: 'measuredValue',
        key: 'measuredValue',
        ellipsis: true
      } 
    ]
  }
  data = []
  selectId = ''
  selectRow = {}
  loading = false
  scrollY = 500
  page:any ={
    current: 1,
    size: 25,
  }
  total = 0
  qualityTestingVisible = false

  clickRow(record){
    this.selectId = record.id
    this.selectRow = record
  }

  showTotal(total) {
    return (this.$t('Total…items') as string).replace('{0}', total)
  }
  
  getHeight(){
    const productionDiv = document.getElementById('quality-statistics-list')
    console.log(productionDiv.clientHeight)
    this.scrollY = productionDiv.clientHeight - 70
  }

  handleTableChange(current: number) {
    this.page.current = current
    this.getList()
  }

  handleEdit(){
    this.qualityTestingVisible = true
  }

  closeQualityTesting(){
    this.qualityTestingVisible = false
    this.reload()
  }

  render() {
    return (
      <div id="quality-statistics-list" style="height: 100%;padding: 8px">
        <div style="padding-bottom: 8px">
          <a-button v-acl={'page_quality_inspection_statistics_edit' + '_' + this.searchDto.typeId} type="primary" disabled={this.selectId === ''} onClick={() => this.handleEdit()}>{this.$t('edit')}</a-button>
        </div>
        <ml-table
          pagination={false}
          columns={this.columns}
          dataSource={this.data}
          bordered
          rowKey="id"
          selectRowKey={this.selectId}
          loading={this.loading}
          scroll={{ y: this.scrollY }}
          customRow={(record) => {
            return {
              on: { // 事件
                click: () => this.clickRow(record),       // 点击行
              },
            };
          }}
        >
        </ml-table>
        <a-pagination
          style="position:absolute;bottom: 4px;right: 20px"
          show-total={total => `${this.showTotal(total)}`}
          current={this.page.current}
          pageSize={this.page.size}
          total={this.total}
          on-change={this.handleTableChange}
          on-showSizeChange={this.handleTableChange}
        />
        <quality-testing
          item={this.selectRow}
          visible={this.qualityTestingVisible}
          onCancel={() => this.closeQualityTesting()}
          onSave={() => this.closeQualityTesting()}
        >
        </quality-testing>
      </div>
    )
  }
}

